import MicroModal from 'micromodal';

const triggers = document.querySelectorAll('[data-micromodal-trigger="share-modal"]');
const shareModal = document.getElementById('share-modal');
const enquireModal = document.getElementById('enquire-modal');
const clipboardBtn = document.getElementById('share-modal-clipboard');

function replaceShareModalLinks() {
	if (triggers.length > 0 && shareModal) {
		triggers.forEach(function(trigger) {
			trigger.addEventListener('click', function() {
				const url = trigger.dataset.propertyUrl;
				const links = shareModal.querySelectorAll('a.pkrd-btn');
				const clipboardBtn = shareModal.querySelector('#share-modal-clipboard');

				links.forEach(function(link) {
					link.href = link.dataset.urlTemplate.replace("[URL]", url);
				})

				clipboardBtn.dataset.propertyUrl = url;
			})
		})
	}

	if (shareModal && clipboardBtn) {
		clipboardBtn.addEventListener('click', function() {
			const url = clipboardBtn.dataset.propertyUrl;
			navigator.clipboard.writeText(url);
			alert("Copied property link:\n" + url);
		})
	}
}

const modalInit = function () {
	if (!shareModal && !enquireModal) {
		return;
	}
	replaceShareModalLinks();
	MicroModal.init({disableFocus: true});

	const urlHash = window.location.hash;
	if (enquireModal && '#enquiry-form' === urlHash) {
		console.log(urlHash);
		MicroModal.show('enquire-modal');
	}
};

export default modalInit;
